<template>
  <section class="section-book-additional-hours p-4">
    <!-- Navigation -->
    <div class="row mb-3">
      <div class="col-12 col-md-8 offset-md-2">
        <router-link to="/my-reservations" class="text-primary-link">
          {{ $t('message.menu.my_reservations') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        <router-link class="text-primary-link" :to="`/reservation/${order.id}`">
          {{ $t('message.my_reservations.reservation_detail') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        {{ $t('message.professional_tip.title') }}
      </div>
    </div>

    <div class="row pt-4">
      <div class="col-12 col-lg-6 offset-lg-3">
        <!-- Section Amount -->
        <section>
          <div>
            <label class="mb-0">{{ $t('message.professional_tip.select_amount') }}</label>
          </div>
          <div class="row no-gutters py-2">
            <div class="col-4 p-2" v-for="(tip, index) in tips" :key="index">
              <button
                class="btn badge badge-pill badge-light text-pro-number text-center w-100"
                :class="[{'active-button' : selectTip === tip }, 'pillTip']"
                @click.prevent="assignTip('select', tip)">
                ฿{{ tip | prettyNumber }}
              </button>
            </div>
          </div>
          <div>
            <div class="py-2 text-secondary">
              {{ $t('message.professional_tip.custom_amount') }}
            </div>
            <input type="number"
                   inputmode="numeric"
                   pattern="[0-9]*"
                   class="form-control"
                   min="20"
                   :max="maxAmount"
                   :placeholder="$t('message.professional_tip.custom_amount_hint')"
                   v-model.number="inputTip"
                   @input="assignTip('input', inputTip)">
            <div class="pt-2 text-remark">
              {{ $t('message.professional_tip.custom_amount_remark') }} {{ maxAmount | prettyNumber }}
            </div>
          </div>
          <div class="py-3">
            <div>
              <span>
                <i class="fas fa-circle bullet-notification"></i> {{ $t('message.professional_tip.remark01') }}
              </span>
            </div>
            <div>
              <span>
                <i class="fas fa-circle bullet-notification"></i> {{ $t('message.professional_tip.remark02') }}
              </span>
            </div>
          </div>
        </section>

        <div class="d-flex justify-content-end">
          <div>
            <label class="mb-0">{{ $t('message.professional_tip.amount') }}</label>
            <span class="-status-new text-pro-number" v-if="totalTip">{{ totalTip | currency }}</span>
          </div>
        </div>

        <!-- Payment -->
        <section>
          <hr/>
          <payment-methods ref="paymentMethods"
                           :displayCreditCardRemark="true"
                           :displayBankTransfer="false"
                           @onSelectedPaymentMethod="updatePaymentMethod"
                           @onSelectedCreditCard="applyUserCreditCard"
                           @onRequestedSavingTempData="saveTempData"
                           @onSuccessQrPayment="displaySuccessDialog"></payment-methods>
        </section>

        <div class="pt-2">
          <button class="btn btn-info btn-block"
                  :disabled="isLoading"
                  v-if="paymentMethod !== 'promptpay'"
                  @click="submitData()">
            {{ isLoading ? $t('message.button.loading') : $t('message.button.ok') }}
          </button>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { orderMixin } from '../../mixins/orderMixin'
  import PaymentMethods from './PaymentMethods'
  import axios from 'axios'

  export default {
    mixins: [orderMixin],
    components: {
      PaymentMethods
    },
    data () {
      return {
        totalTip: 0,
        errorMessages: {},
        tips: [],
        maxAmount: null,
        tipAmount: null,
        selectTip: null,
        inputTip: null,
        paymentMethod: null,
        omiseCustomerId: null,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      }),
      ...mapState('orderDetail', ['tmpProfessionalTipData'])
    },
    watch: {
      purchaseQty () {
        if (this.purchaseQty) {
          if (this.purchaseQty <= 1) {
            this.purchaseQty = 2
          } else if (this.purchaseQty > this.maxQty) {
            this.purchaseQty = this.maxQty
          }
          this.reCalculateCost()
        }
      },
      totalPrice () {
        this.updateQrPayment()
      },
      paymentMethod () {
        this.updateQrPayment()
        this.calculateTip()
      }
    },
    methods: {
      initData () {
        this.errorMessages = {}
        this.tips = this.globalState.professionalTipData.professional_tips
        this.maxAmount = Number(this.globalState.professionalTipData.max_amount)
      },
      clearClass () {
        window.$('button.active-button').removeClass('active-button')
      },
      assignTip (type, tip) {
        this.selectTip = tip
        if (type === 'select') {
          this.inputTip = null
          this.paymentMethod = null
          this.$refs.paymentMethods.setPaymentMethod(null)
        }
        if (type === 'input') {
          this.selectTip = null
          this.paymentMethod = null
          this.clearClass()
          this.$refs.paymentMethods.setPaymentMethod(null)
        }
        this.totalTip = tip
        this.tipAmount = tip
        this.calculateTip()
      },
      calculateTip () {
        this.checkInputTip()
        this.totalTip = this.tipAmount
        if (this.paymentMethod === 'credit_card') {
          // ถ้าเป็น เครดิต + 4%
          let creditCardFee = (4 / 100) * this.tipAmount
          this.totalTip = Number(this.tipAmount) + Number(creditCardFee)
        }
        return this.totalTip
      },
      checkInputTip () {
        if (this.inputTip > this.maxAmount) {
          this.inputTip = this.maxAmount
          this.tipAmount = this.maxAmount
          return this.inputTip
        }
      },
      getProfessionalTipData () {
        const submitData = {
          order_id: this.order.id,
          user_id: this.order.user_id,
          professional_id: this.order.professional_id,
          professional_income: Number(this.tipAmount),
          amount: Number(this.totalTip),
          payment_method: this.paymentMethod,
          omise_customer_id: this.omiseCustomerId
        }
        return submitData
      },
      async updateQrPayment () {
        if (this.paymentMethod === 'promptpay') {
          const url = '/professional-tips'
          const submitData = this.getProfessionalTipData()
          let {data} = await axios.post(url, submitData)
          if (data.error) {
            this.$swal({text: data.message, type: 'error'})
          } else {
            // insert
            const qrPaymentData = {
              amount: Number(this.totalTip),
              professional_tip_id: data.professional_tip.id
            }
            this.$refs.paymentMethods.updateQrPaymentData(qrPaymentData)
          }
        }
      },
      updatePaymentMethod (paymentMethod) {
        this.paymentMethod = paymentMethod
      },
      applyUserCreditCard (data) {
        this.paymentMethod = data.payment_method
        this.omiseCustomerId = data.omise_customer_id
      },
      saveTempData () {
        const professionalTipData = this.getProfessionalTipData()
        this.$store.commit('orderDetail/SET_TMP_PROFESSIONAL_TIP_DATA', professionalTipData)
      },
      displaySuccessDialog (alertMessage = this.$i18n.t('message.payment_method.payment_success')) {
        if (this.tmpProfessionalTipData) {
          this.$store.commit('orderDetail/SET_TMP_PROFESSIONAL_TIP_DATA', null)
        }
        this.$swal({
          text: alertMessage,
          type: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.close')
        }).then((result) => {
          if (result) {
            this.$router.push(`/reservation/${this.order.id}`)
          }
        })
      },
      isValid () {
        this.errorMessages = {}
        if (!this.tipAmount || this.tipAmount < 20) {
          this.$swal({text: this.$i18n.t('message.alert.no_tip_amount')})
          return false
        }
        if (!this.paymentMethod) {
          this.$swal({text: this.$i18n.t('message.alert.select_payment_method')})
          return false
        }
        if (!this.omiseCustomerId) {
          this.$swal({text: this.$i18n.t('message.alert.select_credit_card')})
          return false
        }
        return true
      },
      submitData () {
        if (this.isValid()) {
          switch (this.paymentMethod) {
            case 'credit_card':
            case 'promptpay':
              this.addProfessionalTip()
              break
          }
        }
      },
      async addProfessionalTip () {
        this.isLoading = true
        const professionalTipData = this.getProfessionalTipData()
        const {data} = await axios.post('/professional-tips', professionalTipData)
        this.isLoading = false
        if (!data.error) {
          this.displaySuccessDialog()
        }
      }
    },
    mounted () {
      this.initData()
      // Check temp data
      if (this.tmpProfessionalTipData) {
        setTimeout(() => {
          this.paymentMethod = this.tmpProfessionalTipData.payment_method
          this.$refs.paymentMethods.setPaymentMethod(this.paymentMethod)
        }, 500)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pillTip {
    background-color: #E0E0E0;
  }

  .active-button {
    background-color: #00BCD4;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/GiveProfessionalTip.vue